import React from "react";

export const CAIXABANK_CO_BORROWER_NOTICE = (
  <>
    <h3>{"Información sobre protección de datos"}</h3>
    <p>
      {
        "Te informamos que eres el responsable de la veracidad y exactitud de los datos personales de los cotitulares que, en su caso, nos facilites, así como de cumplir con la normativa de protección de datos."
      }
    </p>
    <p>
      {
        "Manifiestas que esta comunicación de datos se ha realizado bajo un título habilitante adecuado y de que se has informado adecuadamente a los titulares de los datos de los aspectos que exige dicha normativa."
      }
    </p>
    <p>
      {
        "Nosotros mantendremos el secreto sobre esos datos y aplicaremos las medidas de seguridad legalmente exigibles. Mantendrás totalmente indemne a CaixaBank Payments & Consumer frente a cualquier reclamación, responsabilidad, perjuicio y/o sanción (incluidas sanciones de la Agencia Española de Protección de Datos) derivada del tratamiento de los datos de los cotitulares que lleve a cabo CaixaBank Payments & Consumer."
      }
    </p>
  </>
);
